<form [formGroup]="form">
    <div class="row">
        <div class="col-5">
            <rask-label size="10" class="p-0">
                {{ larmnamn }}
            </rask-label>
        </div>
        <rask-input-number formControlName="varningsniva" class="col-3"
            [min]="0"
            [max]="100"
            [step]="1"
            [rule]="validation.varningsniva">
        </rask-input-number>
        <rask-input-number formControlName="larmniva" class="col-3"
            [min]="0"
            [max]="100"
            [step]="1"
            [rule]="validation.larmniva">
        </rask-input-number>
        <div class="col-1 info-padding">
            <rask-info>{{ infotext }}</rask-info>
        </div>
    </div>
</form>
